import Joi from 'joi-browser';

export default {
  name: Joi.string().required()
};
